const prepareClassNames = (classNamesArray) => {
    const preparedArray = classNamesArray.filter((item) => item).join(' ');

    return preparedArray;
};

export default prepareClassNames;
